export default [
  {
    path: '/artist/profile',
    name: 'Artist Profile',
    component: () =>
      import(/* webpackChunkName: 'profile-artist' */ './views/Index.vue')
  },
  {
    path: '/artist/help-desk',
    name: 'Artist Help Desk',
    component: () =>
      import(/* webpackChunkName: 'artist-help-desk' */ './views/HelpDesk.vue')
  }
]
